<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- CONTEÚDO -->
<ng-container *ngIf="viewModules$ | async as vm">
   
<div *ngIf="!loading" class="relative">

    <!-- TABELA DESKTOP -->
    <div class="hidden md:block overflow-x-auto rounded-lg">
        <table class="w-full text-sm text-left text-gray-500 mb-8">
            <thead class="px-2 text-xs text-white bg-westetics-purple-300 mb-2">
                <tr class="text-left">
                    <th scope="col" class="px-5 py-2 font-medium cursor-pointer text-nowrap text-sm" (click)="toggleSort('fullName')">
                        Nome
                        <fa-icon [icon]="orderBy === 'fullName' ? sortBy === 'ASC' ? faSortUp : faSortDown : faSort" class="ml-1"
                            [ngClass]="{'text-westetics-purple-800': orderBy === 'fullName'}"></fa-icon>
                    </th>

                    <th scope="col" class="px-5 py-2 font-medium cursor-pointer text-nowrap text-sm" (click)="toggleSort('email')">
                        Email
                        <fa-icon [icon]="orderBy === 'email' ? sortBy === 'ASC' ? faSortUp : faSortDown : faSort" class="ml-1"
                            [ngClass]="{'text-westetics-purple-800': orderBy === 'email'}"></fa-icon>
                    </th>

                    <th scope="col" class="px-5 py-2 font-medium cursor-pointer text-nowrap text-sm" (click)="toggleSort('isForeigner')">
                        Estrangeiro
                        <fa-icon [icon]="orderBy === 'isForeigner' ? sortBy === 'ASC' ? faSortUp : faSortDown : faSort" class="ml-1"
                            [ngClass]="{'text-westetics-purple-800': orderBy === 'isForeigner'}"></fa-icon>
                    </th>

                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm">
                        Telefone
                    </th>

                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm">
                        RG
                    </th>

                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm">
                        {{ vm.moduleName === 'ALUNOS' ? 'CPF/CNPJ' : 'CPF' }}
                    </th>

                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm">
                        Ações
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let patient of patients" class="border-b hover:bg-gray-50 cursor-pointer" (click)="editEntry(patient.id)">
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        {{ patient.full_name }}
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        {{ patient.email || '-' }}
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        {{ patient.is_foreigner ? 'Sim' : 'Não' }}
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        {{ patient.phone ? getSelectedPhoneCountryFromDto(patient).ddi + ' ' + patient.phone : '-' }}
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        {{ formatRg(patient.rg) }}
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        {{ patient.cpf || '-' }}
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        <div class="flex gap-3">
                            <button
                                (click)="editEntry(patient.id); $event.stopPropagation()"
                                class="cursor-pointer text-westetics-purple-800 hover:text-westetics-purple-600"
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M16.2812 3.9L14.4812 5.7H5.6999V18.3H18.2999V9.5187L20.0999 7.7187V19.2C20.0999 19.4387 20.0051 19.6676 19.8363 19.8364C19.6675 20.0052 19.4386 20.1 19.1999 20.1H4.7999C4.56121 20.1 4.33229 20.0052 4.16351 19.8364C3.99472 19.6676 3.8999 19.4387 3.8999 19.2V4.8C3.8999 4.5613 3.99472 4.33238 4.16351 4.1636C4.33229 3.99482 4.56121 3.9 4.7999 3.9H16.2812ZM19.6364 3.09L20.9099 4.3644L12.6371 12.6372L11.3663 12.6399L11.3645 11.3646L19.6364 3.09Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- CARDS MOBILE/TABLET -->
    <div class="md:hidden space-y-3 mb-6">
        <div *ngFor="let patient of patients" 
             class="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow cursor-pointer"
             (click)="editEntry(patient.id)">
            <div class="flex justify-between items-start mb-3">
                <div class="min-w-0 flex-1">
                    <h3 class="text-sm font-semibold text-westetics-neutral-950 truncate">{{ patient.full_name }}</h3>
                    <p class="text-xs text-westetics-neutral-600 truncate">{{ patient.email || '-' }}</p>
                </div>
                <button
                    (click)="editEntry(patient.id); $event.stopPropagation()"
                    class="p-2 text-westetics-neutral-600 hover:text-westetics-purple-800 hover:bg-westetics-purple-50 rounded-lg transition-colors"
                >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.2812 3.9L14.4812 5.7H5.6999V18.3H18.2999V9.5187L20.0999 7.7187V19.2C20.0999 19.4387 20.0051 19.6676 19.8363 19.8364C19.6675 20.0052 19.4386 20.1 19.1999 20.1H4.7999C4.56121 20.1 4.33229 20.0052 4.16351 19.8364C3.99472 19.6676 3.8999 19.4387 3.8999 19.2V4.8C3.8999 4.5613 3.99472 4.33238 4.16351 4.1636C4.33229 3.99482 4.56121 3.9 4.7999 3.9H16.2812ZM19.6364 3.09L20.9099 4.3644L12.6371 12.6372L11.3663 12.6399L11.3645 11.3646L19.6364 3.09Z" fill="currentColor" />
                    </svg>
                </button>
            </div>
            <div class="grid grid-cols-2 gap-2 text-xs">
                <div>
                    <span class="text-westetics-neutral-500">Telefone:</span>
                    <span class="ml-1 text-westetics-neutral-900">{{ patient.phone ? getSelectedPhoneCountryFromDto(patient).ddi + ' ' + patient.phone : '-' }}</span>
                </div>
                <div>
                    <span class="text-westetics-neutral-500">{{ vm.moduleName === 'ALUNOS' ? 'CPF/CNPJ' : 'CPF' }}:</span>
                    <span class="ml-1 text-westetics-neutral-900">{{ patient.cpf || '-' }}</span>
                </div>
                <div *ngIf="patient.rg">
                    <span class="text-westetics-neutral-500">RG:</span>
                    <span class="ml-1 text-westetics-neutral-900">{{ formatRg(patient.rg) }}</span>
                </div>
                <div>
                    <span class="text-westetics-neutral-500">Estrangeiro:</span>
                    <span class="ml-1 text-westetics-neutral-900">{{ patient.is_foreigner ? 'Sim' : 'Não' }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Mensagem quando não há registros -->
    <div *ngIf="patients.length === 0 && !loading" class="text-center py-8 text-westetics-neutral-600">
        Nenhum {{ vm.moduleNameInSingular || 'registro' }} encontrado.
    </div>

    <!-- PAGINADOR -->
    <div *ngIf="patients.length > 0" class="flex flex-col lg:flex-row items-center justify-between gap-3 py-4 px-3 lg:px-5">
      <!-- Info de resultados -->
      <div class="text-xs lg:text-sm text-gray-600 order-3 lg:order-1">
        Mostrando {{ (currentPage * pageSize) + 1 }} - {{ Math.min((currentPage + 1) * pageSize, totalElements) }} de {{ totalElements }} {{ moduleLabel }}
      </div>
      
      <!-- Controles de paginação -->
      <div class="flex items-center gap-1 lg:gap-2 order-1 lg:order-2">
        <!-- Botão Anterior -->
        <button (click)="goToPreviousPage()" 
                [disabled]="currentPage === 0"
                [ngClass]="{'opacity-50 cursor-not-allowed': currentPage === 0}"
                class="p-2 lg:px-3 lg:py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
        </button>
        
        <!-- Números das páginas -->
        <div class="flex items-center gap-1">
          <button *ngFor="let page of generatePagination(currentPage + 1, totalPages)"
                  (click)="navigateTo(page)"
                  [disabled]="page === '...'"
                  [ngClass]="{
                    'bg-westetics-purple-600 text-white': page === currentPage + 1,
                    'hover:bg-gray-50': page !== currentPage + 1 && page !== '...',
                    'cursor-default': page === '...'
                  }"
                  class="min-w-[32px] lg:min-w-[36px] px-2 lg:px-3 py-1.5 lg:py-2 border border-gray-300 rounded-md transition-colors text-xs lg:text-sm">
            {{ page }}
          </button>
        </div>
        
        <!-- Botão Próximo -->
        <button (click)="goToNextPage()" 
                [disabled]="currentPage + 1 >= totalPages"
                [ngClass]="{'opacity-50 cursor-not-allowed': currentPage + 1 >= totalPages}"
                class="p-2 lg:px-3 lg:py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
          </svg>
        </button>
      </div>

      <!-- Seletor de itens por página -->
      <div class="flex items-center gap-2 text-xs lg:text-sm order-2 lg:order-3">
        <span class="text-gray-600">Por página:</span>
        <select [value]="pageSize" (change)="onPageSizeChange($any($event.target).value)"
                class="px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-westetics-purple-500">
          <option *ngFor="let option of pageSizeOptions" [value]="option.value">{{ option.label }}</option>
        </select>
      </div>
    </div>
</div>
</ng-container>

<!-- Modal de Confirmação de Exclusão -->
<div *ngIf="showConfirmDeletePopup" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-lg p-4 sm:p-6 w-full max-w-[400px] shadow-lg">
        <div class="flex justify-between items-center mb-4">
            <h2 class="font-bold text-base sm:text-lg text-westetics-neutral-950">Confirmar Exclusão</h2>
            <button (click)="closeDeleteModal()" class="text-westetics-neutral-600 hover:text-westetics-neutral-900">
                <fa-icon [icon]="faTimes"></fa-icon>
            </button>
        </div>
        <p class="text-xs sm:text-sm text-westetics-neutral-800 mb-4 sm:mb-6">
            Tem certeza que deseja excluir este {{ moduleNameSingular }}? Esta ação não pode ser desfeita.
        </p>
        <div class="flex justify-end gap-2 sm:gap-3">
            <button
                (click)="closeDeleteModal()"
                class="px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium text-westetics-neutral-800 bg-westetics-neutral-200 rounded-lg hover:bg-westetics-neutral-300"
            >
                Cancelar
            </button>
            <button
                (click)="onDelete()"
                class="px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700"
            >
                Excluir
            </button>
        </div>
    </div>
</div>

<!-- Modal de Contratos Pendentes de Assinatura do Paciente -->
<div *ngIf="showPendingContractsPopup" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-lg p-4 sm:p-6 w-full max-w-[500px] shadow-lg">
        <h2 class="font-bold text-lg sm:text-xl text-red-600 mb-4">Atenção!</h2>
        <p class="text-xs sm:text-sm text-gray-800 mb-4">
            Você possui <strong>{{ pendingContracts }}</strong> contrato(s) aguardando assinatura do paciente há mais de 3 dias.
            <br><br>
            Estes são contratos que foram enviados mas ainda não foram assinados pelo paciente.
            Para garantir a segurança jurídica da clínica, recomendamos que você resolva essas pendências o quanto antes.
        </p>

        <!-- Checkbox -->
        <div class="flex items-center mb-4 py-4 border-t border-gray-200">
            <input type="checkbox" id="agreeCheckbox" [(ngModel)]="agreeChecked" class="mr-2 w-4 h-4 accent-westetics-purple-600">
            <label for="agreeCheckbox" class="text-xs sm:text-sm text-gray-700">Entendo os riscos legais envolvidos!</label>
        </div>

        <!-- Botões -->
        <div class="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3">
            <button (click)="navigateToSignatures()"
                class="w-full sm:w-auto px-4 py-2 text-xs sm:text-sm font-medium text-white bg-transparent border bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600 hover:text-white transition-colors">
                Ver Assinaturas Pendentes
            </button>
            <button (click)="closePendingContractsPopup()" [disabled]="!agreeChecked"
                class="w-full sm:w-auto px-4 py-2 text-xs sm:text-sm font-medium rounded-lg border border-westetics-purple-800 transition-colors"
                [ngClass]="{
                    'cursor-not-allowed opacity-50': !agreeChecked,
                    'text-westetics-purple-800 hover:bg-westetics-purple-800 hover:text-white': agreeChecked,
                    'text-westetics-purple-800': !agreeChecked
                }">
                Fechar
            </button>
        </div>
    </div>
</div>
